import styled, { css, keyframes } from 'styled-components';
import { media, Row, DeprecatedGrid as Grid } from '@simplywallst/ui-core';

export const Container = styled('section')<{ wide?: boolean }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  color: white;
  position: relative;
  ${media.lgUp`
    padding: ${(props) => props.theme.x2spacePx}px;
    padding-top: 0;
  `}
  transition: 0.6s all cubic-bezier(0.83, 0, 0.17, 1);
  ${(props) => {
    if (props.wide) {
      return css`
        max-width: 1582px;
        @media (min-width: 1440px) and (max-width: 1582px) {
          max-width: 1375px;
        }
        @media (min-width: 1024px) and (max-width: 1439px) {
          max-width: ${props.theme.lgMax};
        }
      `;
    }
    return `max-width: ${props.theme.lgMax}`;
  }}
`;

export const FixedWrapper = styled('div')<{ wide?: boolean }>`
  width: 100%;
  max-width: 1167px;
  ${(props) => {
    if (props.wide) {
      return css`
        @media (min-width: 1440px) and (max-width: 1582px) {
          max-width: 981px;
        }
      `;
    }
  }}
  ${media.mdDown`
    width: 100%;
  `}
`;
export const CompanyReportWrapper = styled('article')`
  position: relative;
`;

export const SectionWrapper = styled('section')`
  background-color: ${(props) => props.theme.color.noir};
  ${media.lgUp`
    border-radius: ${({ theme }) => theme.x1spacePx}px;
  `}
  @media print {
    break-inside: avoid;
  }
`;

export interface PrintWatermarkProps {
  canShowLogo?: boolean;
}
export const PrintModeWatermark = styled(Row)<PrintWatermarkProps>`
  position: fixed;
  z-index: 9999;
  bottom: 0;
  right: 0;
  color: ${({ theme }) => theme.color.white} !important;
  width: 100%;
  align-items: center;
  justify-content: ${({ canShowLogo }) =>
    canShowLogo ? 'space-between' : 'flex-end'};
  > svg {
    height: auto;
    width: 150px;
  }
  > img {
    height: auto;
    width: 150px;
  }
  padding: ${({ theme }) => theme.x4space}px;
`;

export const WatermarkCopy = styled('span')`
  font-size: ${({ theme }) => theme.x2spacePx}px;
`;

export const Logo = styled('div')<PrintWatermarkProps>`
  display: ${({ canShowLogo }) => (canShowLogo ? 'inline' : 'none')};
  img {
    height: 50px;
  }
`;

interface LoadingStyledProps {
  isShowLoading?: boolean;
}

const LoadContainerLoading = css`
  position: relative;
  overflow: hidden;
  height: calc(
    100vh - ${({ theme }) => theme.desktopTopbarHeight + theme.x2spacePx}px
  );
`;

const reveal = keyframes`
	from {opacity: 0;}
	to {opacity: 1;}
`;

const LoadContainerFinished = css`
  position: static;
  height: auto;
  overflow: visible;
  animation: ${reveal} 0.25s linear backwards;
`;

export const LoadingContainer = styled.div<LoadingStyledProps>`
  ${({ isShowLoading }) =>
    isShowLoading ? LoadContainerLoading : LoadContainerFinished}
`;

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  text-align: center;
`;

export const LoadingGrid = styled(Grid)`
  height: 100%;
`;

const reportContentLoading = css`
  position: absolute;
  top: 0;
  z-index: -1;
  opacity: 0;
`;

const reportContentFinished = css`
  position: static;
  top: auto;
  z-index: 0;
  opacity: 1;
`;

export const ReportContentWrapper = styled.div<LoadingStyledProps>`
  ${({ isShowLoading }) =>
    isShowLoading ? reportContentLoading : reportContentFinished}
`;

export const LoadingContent = styled(Grid)`
  padding: ${({ theme }) => `${theme.x4spacePx}px`};
`;

interface CompanyReportTableRowProps {
  selected?: boolean;
}

export const CompanyReportTableRow = styled('tr')<CompanyReportTableRowProps>`
  ${({ selected, theme }) => selected && `color: ${theme.color.white};`}
  &&& {
    ${({ selected, theme }) =>
      selected && `background: ${theme.color.brand01RGBA(0.1)};`}

    &:hover {
      ${({ selected, theme }) =>
        !selected && `background: ${theme.color.whiteRGBA(0.05)};`}
    }
  }

  ${({ selected, theme }) =>
    selected &&
    css`
      & > td:first-of-type {
        position: relative;

        ::before {
          content: ' ';
          display: block;
          position: absolute;
          width: 4px;
          background-color: ${theme.color.brand01};
          left: 0;
          top: 0;
          bottom: 0;
        }
      }
    `}
`;
